/* This is only to implement order methods */

export const getCurrencyCodeFromSymbol = (symbol) => {

  switch(symbol) {
    /*case "₹": {
      return 'INR';
    }*/

    case "$": {
      return 'USD';
    }

    default: {
      return 'INR';
    }
  }

}
